export const regexValidation = {
  URL_REGEX: /(((https?):\/\/)(www.)?)[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
  CONTACT_NUMBER_REGEX: /(\+\d{1,3})(((\d{3}))|(\d{3}))(\d{3})(\d{4})/,
  EMAIL_REGEX: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
};
